import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

export default {
  getGame(code) {
    return apiClient.get('/game/' + code)
  },
  createTeam(code, teamName) {
    return apiClient.post('/game/' + code, {
      teamName
    })
  },
  createDemoGame(gameType) {
    return apiClient.get('/action/generateDemoGame/' + gameType)
  },
  addMemberToTeam(code, teamId, teamMemberName) {
    return apiClient.post('/game/' + code + '/' + teamId + '/addMember', {
      teamMemberName
    })
  },
  requestHintForQuestion(code, teamId, challengeIndex, questionIndex) {
    return apiClient.post(
      '/game/' +
        code +
        '/' +
        teamId +
        '/' +
        challengeIndex +
        '/' +
        questionIndex +
        '/useHint'
    )
  },
  updateProposedChallenge(code, teamId, proposedChallengeIndex, proposerName) {
    return apiClient.post(
      '/game/' + code + '/' + teamId + '/proposedChallenge',
      { proposedChallengeIndex, proposerName }
    )
  },
  updateCurrentChallenge(code, teamId, currentChallengeIndex) {
    return apiClient.post(
      '/game/' + code + '/' + teamId + '/currentChallenge',
      { currentChallengeIndex }
    )
  },
  updateCurrentQuestion(code, teamId, challengeIndex, currentQuestionIndex) {
    return apiClient.post(
      '/game/' +
        code +
        '/' +
        teamId +
        '/' +
        challengeIndex +
        '/currentQuestion',
      { currentQuestionIndex }
    )
  },
  answerQuestion(code, teamId, challengeIndex, questionIndex, answerData) {
    return apiClient.post(
      '/game/' +
        code +
        '/' +
        teamId +
        '/' +
        challengeIndex +
        '/' +
        questionIndex,
      answerData
    )
  }
}
